// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".opacity-0[data-v-e237fa50]{opacity:0}@media(max-width: 768px){.manage-ellipsis[data-v-e237fa50]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:200px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
